import styled from '@emotion/styled';
import MuiAvatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';

import { ButtonWrapper } from '~/src/components/cards/elements';
import {
  black87,
  breakpoints,
  charcoalGrey,
  darkGrey,
  greyBackground,
  greyish,
  pinkishOrange,
  steelGrey,
  turquoise,
  veryLightGrey,
} from '~/styles';

// ygi-learn-article__related-topics
export const LearnArticleRelatedTopics = styled.div`
  display: flex;
  align-items: center;
  margin: 14px 0;
  ${breakpoints.minTablet} {
    margin: 3vh 0 0px;
  }
`;

// ygi-learn-article__related-topics__header
export const LearnArticleRelatedTopicsHeader = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.33;
  margin: 0 25px 0 0;
  color: ${charcoalGrey};
`;

// ygi-learn-article__related-topics__topic
export const LearnArticleRelatedTopicsTopic = styled(Chip)`
  background-color: ${veryLightGrey};
  font-weight: 200;
  line-height: 1.43;
  letter-spacing: 0.25px;
  color: ${black87};
  margin: 3px;
`;

export const ArticleBody = styled.div`
  padding: 0px;
  ${breakpoints.minMobileLandscape} {
    padding: 0px 0px 30px;
    margin-bottom: 0px;
  }
  ${breakpoints.minTabletLandscape} {
    padding: 0 194px 0 194px;
    margin-bottom: 21px;
  }

  img {
    max-width: 100%;
  }

  p {
    color: ${steelGrey};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75;
    letter-spacing: 0.5px;
  }

  a,
  a:hover {
    color: ${pinkishOrange};
  }

  h2,
  h3 {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.38;
    letter-spacing: 5px;
    font-size: 1.2rem;
    line-height: 1.33;
    letter-spacing: -0.3px;
    margin: 30px 0 16px;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.56;
    color: ${charcoalGrey};
    font-size: 0.9rem;
    margin-top: 30px;
    margin-bottom: 16px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${turquoise};
    text-transform: uppercase;
    font-weight: 700;
  }

  h6 {
    font-size: 12px;
  }

  ul {
    font-size: 1.125rem;
    line-height: 1.5;
    color: ${steelGrey};

    list-style-type: none;
    padding: 16px 0 16px 50px;
  }

  li {
    padding: 10px 0;
    position: relative;
    color: ${steelGrey};
    font-weight: 300;
    font-size: 0.9rem;

    &::before {
      content: '•';
      position: absolute;
      font-size: 30px;
      left: -30px;
      top: -3px;
    }
  }

  blockquote p {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: ${pinkishOrange};
    text-align: center;
    padding: 30px 50px;
  }
`;

// yi-article-body__class-key
export const ArticleBodyClassKey = styled(Grid)`
  padding-top: 20px;
  margin-bottom: 30px;
  p {
    line-height: 1;
    font-size: 14px;
    margin-bottom: 10px;
  }
`;

// yi-article-body__class-category
export const ArticleBodyClassCategory = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
`;

// yi-article-body-author-wrapper
export const ArticleBodyAuthorWrapper = styled.div`
  padding: 4.5%;
  padding-top: 0px;
  margin: 0px -4% 0px -4%;
  margin-bottom: 16px;
  padding-bottom: 13%;
  ${breakpoints.minMobileLandscape} {
    padding-top: 0px;
  }
  ${breakpoints.minTablet} {
    padding: 4.5%;
    margin: 0px -4% 0px -4%;
  }

  ${breakpoints.minTabletLandscape} {
    padding: 2% 1%;
    margin-bottom: 60px;
    margin: 0 20% 3% 20%;
    background-color: ${greyBackground};
    border-radius: 5px;
  }
`;

// ygi-related-articles__heading
export const RelatedArticlesHeading = styled.h2`
  text-transform: uppercase;
  font-size: 2rem;
  letter-spacing: 2.2px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 20px;
  color: ${charcoalGrey};
  width: 100%;
  text-align: center;
`;

// ygi-featured-teacher__follow-btn
export const TeacherFollowButton = styled.button`
  font-size: 0.8125rem;
  font-weight: 500;

  color: ${pinkishOrange};
  border: 1px solid ${pinkishOrange};
  border-radius: 2px;
  padding: 3px 9.5px;
  width: 85px;
  background-color: transparent;
  height: auto;
  max-height: 48px;

  &:hover {
    cursor: pointer;
    background: ${pinkishOrange};
    color: #fff;
  }

  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  border: 1px solid ${pinkishOrange};
  background: ${pinkishOrange};

  &.following,
  &:hover {
    background: none;
    color: ${pinkishOrange};
    border-color: ${pinkishOrange};
  }

  &.following:hover {
    color: #fff;
    border-color: ${pinkishOrange};
    background: ${pinkishOrange};
  }
`;

export const ChevronWrapper = styled.div`
  text-align: right;
  margin: auto;
`;

// ygi-learn-article__heading-banner
export const LearnArticleHeadingBanner = styled.div`
  background-color: #fff;
  padding: 30px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 1140px;
`;

// ygi-icon-group

export const BannerImage = styled.section<{ img?: string }>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
  background-image: ${({ img }) => img};
  width: auto;
  height: 40vh;
  margin-top: 10px;
  min-height: 20vh;
  ${breakpoints.minMobileLandscape} {
    min-height: 50vh;
    height: auto;
    margin-top: 0;
  }
  ${breakpoints.minTablet} {
    min-height: 60vh;
  }
  ${breakpoints.minTabletLandscape} {
    min-height: 90vh;
  }

  @media print {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }
`;

export const Avatar = styled(MuiAvatar)`
  display: inline-flex;
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

// ygi-video-class-banner--mobile-background
export const MobileBackground = styled.div`
  height: auto !important;
  ${breakpoints.minMobileLandscape} {
    display: none;
  }
`;

// ygi-video-class-banner__heading
export const Heading = styled.h1`
  font-size: 19px;
  font-weight: 300;
  letter-spacing: 0.25px;
  color: ${greyish};

  text-align: left;
  margin-inline-end: auto;
  text-transform: none;

  margin-bottom: 50px;
  ${breakpoints.minMobileLandscape} {
    margin-bottom: 50px;
  }
`;

export const SubHeading = styled(Heading)`
  font-size: 14px;
  margin-bottom: 30px;
  color: white;
`;

export const FavoriteButtonWrapper = styled(ButtonWrapper)`
  text-align: right;
  justify-content: center;
  margin-top: 10px;
  margin-right: 20px;
  ${breakpoints.minMobileLandscape} {
    margin-right: 26px;
  }
`;

// ygi-video-class-banner__author
export const Author = styled.div`
  font-size: 1rem;
  line-height: 1.75;
`;

export const BannerWrapper = styled.div`
  background-color: ${darkGrey};
  padding: 0px;

  ${breakpoints.minDesktopLg} {
    padding: 0px 80px 0px;
  }
  ${breakpoints.minTablet} {
    padding: 0px 80px 0px;
  }

  ${breakpoints.minDesktop} {
    padding: 0px;
  }
`;

export const ClassStyleAndLevel = styled.div`
  color: ${turquoise};
  font-size: 12px;
  font-weight: normal;
  line-height: 1.34;
  letter-spacing: 2px;
  margin-left: 0px;
  padding-bottom: 15px;
  text-transform: uppercase;
  width: max-content;
  display: flex;
  gap: 8px;
`;

export const DurationIconButtonWrapper = styled.div`
  padding: 4px;
  margin-left: 0;
  margin-right: initial;
  ${breakpoints.minMobileLandscape} {
    margin-left: 70%;
  }
  ${breakpoints.minTablet} {
    margin: auto;
  }
`;

// ygi-video-class-banner__wrapper
export const InfoSection = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 95%;
  padding: 15px 16px 0px;
  height: 50%;
  margin: auto;
  ${breakpoints.minMobileLandscape} {
    width: 100%;
    padding-bottom: 0px;
    padding: 36px;
  }

  ${breakpoints.minTabletLandscape} {
    width: 70%;
  }

  ${breakpoints.minDesktop} {
    width: 52%;
  }

  ${breakpoints.minDesktopLg} {
    width: 42%;
    max-width: 650px;
    margin: auto;
    padding: 24px 0px 0px;
  }
`;

export const BannerTopMenuWrapper = styled.div`
  width: 100%;
  position: absolute;
  z-index: 1;
`;
